"use strict";
/*
 * THIS MATERIAL IS THE CONFIDENTIAL, PROPRIETARY AND TRADE SECRET PRODUCT OF
 * BLUECROSS BLUESHIELD OF SOUTH CAROLINA AND ITS SUBSIDIARIES.  ANY
 * UNAUTHORIZED USE, REPRODUCTION OR TRANSFER OF THESE MATERIALS IS STRICTLY
 * PROHIBITED.
 * COPYRIGHT 2021 BLUECROSS BLUESHIELD OF SOUTH CAROLINA   ALL RIGHTS
 * RESERVED.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCookie = exports.getCookie = void 0;
/**
 * Retirieve specfied cookie value
 * @args cookieName
 * @returns the decoded value of the cookie
 */
function getCookie(cookieName) {
    const name = cookieName + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (const crumb of cookieArray) {
        let curCrumb = crumb;
        while (curCrumb.charAt(0) == ' ') {
            curCrumb = curCrumb.substring(1);
        }
        if (curCrumb.indexOf(name) == 0) {
            return curCrumb.substring(name.length, curCrumb.length);
        }
    }
    return '';
}
exports.getCookie = getCookie;
function setCookie(name, value, optionsOrEnd = {}, path, domain, sameSite, isSecure) {
    let end;
    if (['[object Null]', '[object Number]', '[object String]', '[object Date]'].includes(Object.prototype.toString.call(optionsOrEnd))) {
        end = optionsOrEnd;
    }
    else {
        ({ end, path, domain, sameSite, isSecure } = optionsOrEnd);
    }
    if (!name || /^(?:expires|max-age|path|domain|secure)$/i.test(name)) {
        return false;
    }
    let sExpires = '';
    if (end) {
        switch (end.constructor) {
            case Number:
                sExpires = end === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + end;
                break;
            case String:
                sExpires = '; expires=' + end;
                break;
            case Date:
                sExpires = '; expires=' + end.toUTCString();
                break;
        }
    }
    if (sameSite) {
        switch (sameSite) {
            case 'None':
            case 'Lax':
            case 'Strict':
                break;
            default:
                return false;
        }
    }
    document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + sExpires
        + (domain ? '; domain=' + domain : '') + (path ? '; path=' + path : '')
        + (sameSite ? '; SameSite=' + sameSite : '') + (isSecure ? '; secure' : '');
    return true;
}
exports.setCookie = setCookie;
//# sourceMappingURL=cookie.js.map